export const en = {

    // Login
    loginTitle: 'Welcome',
    loginMessage: 'Enter your Login',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    newPassword: 'New Password',
    repeatNewPassword: 'Repeat New Password',
    authenticateUser: 'Authenticate User',
    recoverPassword: 'Recover Password',
    recoverPasswordDescription: 'Check your Email and Follow Instructions to Reset your Password',
    forgotPassword: 'Forgot Password',
    code: 'Code',
    acceptWordOs: 'Accept',
    acceptWordAs: 'Accept',
    termsConditions: 'Terms & Conditions',
    cookies: 'Cookies Policy',
    privacyRule: 'Accept',
    privacyRuleLink: 'Data Confidentiality',
    repeatPasswordLabel: 'Repeat the Password used above',
    inputLabelNewPassword: 'Password must Respect the Requirements',
    logout: 'Logout',
    'User Authenticated': 'User Authenticated',
    "Without access": "Without access",
    "You currently have no permissions. Please contact the administrator": "You currently have no permissions. Please contact the administrator",


    //---- Nav Bar Items-----
    inicio: 'Home',
    municipality: 'Municipality',
    territory: 'Territory',
    autarchy: 'Autarchy',
    entity: 'Entity',
    emissions: 'Emissions of GEE in Territory',

    map: 'Map',
    politicas: 'Policies',
    events: 'Events',
    registry: 'Registry',
    registrationManagement: 'Registration Management',
    searchForAsset: 'Search by Asset',
    searhForResource: 'Search by Asset Code',
    Energy: 'Energy',
    analytics: 'Analytics',
    timeLine: 'Timeline',

    configurations: 'Configurations',

    //----- Buttons --------
    seeOnMap: 'See on Map',
    delete: 'Delete',
    add: 'Add',
    clear: 'Clear',
    lines: 'Lines',
    bars: 'Bars',
    heatmap: 'HeatMap',
    report: 'Report',
    exportRawData: 'Export Raw Data',
    signIn: 'Sign In',
    resetPassword: 'Reset Password',
    sendEmail: 'Send Email',
    edit: 'Edit',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    seeDetail: 'See Detail',
    upload: 'Upload',
    deleteDescription: 'Are you sure you want to delete the item?',
    "Show Metrics": "Show Metrics",
    create: 'Create',

    //------------
    search: 'Search',
    selectPeriod: 'Select Period',

    //------ Date Formats -----
    day: 'day',
    days: 'Days',
    week: 'Week',
    weeks: 'Weeks',
    months: 'Months',
    year: 'Year',
    years: 'Years',
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    startDate: 'Start date',
    endDate: 'End date',
    annual: 'Annual',
    monthly: 'Monthly',
    quarter: 'Quarter',
    yearly: 'Yearly',
    raw: 'Raw',

    jan: 'jan',
    feb: 'feb',
    mar: 'mar',
    apr: 'apr',
    may: 'may',
    jun: 'jun',
    jul: 'jul',
    aug: 'aug',
    sep: 'sep',
    oct: 'oct',
    nov: 'nov',
    dec: 'dec',
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",

    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday",

    //------------
    data: 'Data',
    name: 'Name',

    simple: 'Simple',
    biHourly: 'Bi-hourly',
    triHourly: 'Tri-hourly',
    tetraHourly: 'Tetra-hourly',

    page: 'Page',
    seeMore: 'See More',
    seeLess: 'See Less',
    'and others': 'and others',

    simulatedTariffs: 'Simulated Tariffs',
    Floor1: "1 Floor",
    Floor2: "2 Floor",
    Floor3: "3 Floor",
    Floor4: "4 Floor",
    Floor5: "5 Floor",
    Floor6: "6 Floor",
    Floor7: "7 Floor",
    Floor8: "8 Floor",
    Floor9: "9 Floor",
    Floor10: "10 Floor",

    //------------ Tooltips -----------
    passwordRequirements: 'Password Requirements',
    minimunCharacters: '8 minimun characters',
    numberCharacter: 'Contains at least 1 number',
    uppercaseLetter: 'Contains at least 1 uppercase letter',
    lowercaseLetter: 'Contains at least 1 lowercase letter',
    specialCharacter: 'Contains at least 1 special character',
    dataBasedEReded: 'Generated based on the latest E-REDES Open Data data',
    dataRefersToYear: 'Data refers to the year of ',
    comparingElectricityConsumption: 'Comparing Electricity Consumption',
    heatmapExplained: 'Heatmap generated using  the Distribution Transformer Stations consumption of the Territory',
    heatmapTooltip: 'Heatmap showing the electricity consumption density of the territory',
    "The graph shows the average data for the last four weeks, grouped by each day of the week. Each point reflects the average of the values recorded on a given day over the last four weeks, allowing daily trends to be observed.": "The graph shows the average data for the last four weeks, grouped by each day of the week. Each point reflects the average of the values recorded on a given day over the last four weeks, allowing daily trends to be observed.",
    "Percentage reflects bookings in relation to the number of seats available": "Percentage reflects bookings in relation to the number of seats available",
    'Periodicity Tooltip': 'Returns the last 12 hours of the selected date',
    "Drawer Weight Tooltip": "Edge weight, which represents the percentage of the impact that an Issues has on the child node",
    "Drawer Is Peer Tooltip": "Parity relationship, indicating whether the relationship is between nodes of the same hierarchical level or of the parent-child type",
    "Drawer Invname Tooltip": "Child node name of the relation",
    "Drawer Outvname Tooltip": "Parent node name of the relation",
    "tooltip.category_tooltip": "Firstly, you need to select a location",

    //------------ AuthContext Errors -----------
    incorrectFields: 'Incorrect Username or Password',
    passwordNoMatch: 'Passwords don´t match',
    passwordNotValid: 'Password doesn´t match the requirements',
    emailSentCode: 'Email sent with the verification code',
    codeSentByMessage: 'Code sent by message',
    firstLogin: 'First login, user needs to authenticate',
    errorResetPassword: 'Something went wrong, please check the code or password requirements',
    infoDescription: 'Can´t export when there are no data available',

    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',

    successAdd: 'Items added with success.',
    errorAdd: 'Error: item not added.',

    successDelete: 'Items deleted with success.',
    errorDelete: 'Error: item not deleted.',

    errorGettingCertificates: 'An error occurred getting certificate list.',

    //--------------------- Filters -----------------
    filters: 'Filters',
    rester: 'Reset',
    savedFilters: 'Saved Filters',
    apply: 'Apply',
    "All": "All",
    "Clear Options": "Clear Options",
    "User withou a tenant": "User withou a tenant",
    "All Clusters": "All Clusters",

    //--------------------- Classes -----------------
    "Buildings": "Buildings",
    "Facilities": "Facilities",
    "Office": "Office",
    "Social": "Social",
    "Pavilion": "Pavilion",
    "School": "School",
    "Storage": "Storage",
    "Meeting Room": "Meeting Room",
    "Expresso Corner": "Lounge",
    "Level Floor": "Level Floor",

    //--------------------- Home -----------------
    "Total Buildings": "Total Buildings",
    "Types of Buildings": "Types of Buildings",
    "General Information of Buildings": "General Information of Buildings",
    "Occupation in the Buildings": "Occupation in the Buildings",
    "Average Occupation": "Average Occupation",
    "Top 5 Highest Occupancy": "Top 5 Highest Occupancy",
    "Top 5 Lowest Occupancy": "Top 5 Lowest Occupancy",
    "Top 5 Highest Consumption": "Top 5 Highest Consumption",
    "Top 5 Lowest Consumption": "Top 5 Lowest Consumption",
    'Garage Occupation': 'Garage Occupation',
    'Garage Number': 'Garage Number',
    'Available Parking Spaces': 'Available Parking Spaces',
    'Medium Occupation': 'Medium Occupation',
    'Buildings Water Consumption': 'Buildings Water Consumption',
    "Current Incidents": "Current Issues",
    "Top 5 Incidents": "Top 5 Issues",
    "Buildings Energetic Consumption": "Buildings Energetic Consumption",
    "Average Consumption": "Average Consumption",
    "Energy Consumption": "Energy Consumption",
    "Building Comfort": "Building Comfort",
    'Building Occupation': 'Building Occupation',
    "Capacity": "Capacity",
    "Consumption per Floor": "Consumption per Floor",

    //--------------------- Mapa -----------------
    "Incidents": "Issues",
    "Incident": "Issues",
    "Incidents Number": "Number of Issues",
    "Incidents Number": "Issues Number",
    "Services": "Locations",
    "Low": "Low",
    "Medium Low": "Medium Low",
    "Medium": "Medium",
    "Medium High": "Medium High",
    "High": "High",
    "Incidents by Level": "Issues by Level",
    "Field Incidents": "Field Issues",
    "Unassigned Incidents": "Unassigned Issues",
    "Select Services with Incidents": "Select Locations with Issues",
    "Select Services": "Select Locations",
    'Select classes': 'Select Locations',
    "Select Priorities": "Select Severities",
    "Select Severities": "Select Severities",
    "View Map": "View Map",
    "Quick Access": "Quick Access",
    "Consumption By User": "Consumption By User",
    "Building Consumption": "Building Consumption",
    "Back": "Back",
    "button.create_incident": "Create Issues",
    "action.create_incident": "Create Issues",
    "button.digital_twin": "Digital Twin",
    "button.incidents": "Issues",
    "Incident Description": "Issues Description",
    "Manage Issue": "Manage Issue",
    "Issue number": "Issue number",
    "Last update": "Last update",
    "Impacted FA": "Impacted FA",
    "Service Name": "Location Name",
    "View Details": "View Details",
    "Address": "Address",
    "Location": "Location",
    "SubType": "SubType",
    "ImpactedFA": "Impacted FA",
    "Subtype": "Subtype",
    "notification.success_create_incident": "Issue created successfully",
    "notification.error_create_incident": "Error creating Issue",
    "headlineStatus": "Headline Status",
    "lastUpdate": "Last Update",
    "impactedFA": "Impacted FA",
    "location": "Location",
    "description": "Description",
    "priority": "Severity",
    "issueOwnerGroup": "Owner Group",

    //--------------------- Assets -----------------
    "Assets": "Assets",

    //--------------------- OBJ Translations -----------------
    "Salas disponíveis": "Available Rooms",
    "Salas ocupadas": "Occupied Rooms",
    "Occupied Rooms": "Occupied Rooms",
    "Available Rooms": "Available Rooms",

    //--------------------- Building Details -------
    "View": "View",
    "Overview": "Overview",
    "Occupation": "Occupation",
    "Room Detail": "Room Detail",
    "Comfort": "Comfort",
    "Parking": "Parking",
    "button.daily_analysis": "Daily Analysis",
    "button.historic": "Historic",
    "button.buildings_detail": "Buildings Detail",
    "Digital Twin": "Digital Twin",
    "Energetic Consumption": "Energetic Consumption",
    "Average Energy Consumption": "Average Energy Consumption",
    "Energy consumption per user": "Energy consumption per user",
    "Evolution of floor energy consumption": "Evolution of floor energy consumption",
    "Consumption per Hour": "Consumption per Hour",
    "Energy Consumption per user": "Energy Consumption per user",
    "Building Energy Consumption Evolution": "Building Energy Consumption Evolution",
    "Peak of the month": "Peak of the month",
    "Evolution of floor energy consumption during the day": "Evolution of floor energy consumption during the day",
    "Room Details": "Room Details",
    "Vacant Rooms": "Vacant Rooms",
    "Vacant": "Vacant",
    "Check-In and Room Reservation": "Check-In and Room Reservation",
    "Room Occupation": "Room Occupation",
    "Lighting": "Lighting",
    "Temperature": "Temperature",
    "Humidity": "Humidity",
    "Air Quality": "Air Quality",
    "Noise": "Noise",
    "Luminosity": "Luminosity",
    "Building": "Building",
    "Floor": "Floor",
    "Average Value": "Average Value",
    "Average Ideal Temperature": "Average Ideal Temperature",
    "Ideal Value": "Ideal Value",
    "Temperature Variation": "Temperature Variation",
    "Humidity Variation": "Humidity Variation",
    "Air Quality Variation": "Air Quality Variation",
    "Lightning Variation": "Lightning Variation",
    "Noise Variation": "Noise Variation",
    "Lighting Variation": "Lighting Variation",
    "Average Reservations Made": "Average Reservations Made",
    "Average Check-ins Made": "Average Check-ins Made",
    "Average Missing Checkout": "Average Missing Checkout",
    "Rooms Reservations": "Rooms Reservations",
    "Rooms Check-in Carried Out": "Rooms Check-in Carried Out",
    "Seats Reservation": "Seats Reservation",
    "Map Occupation": "Map Occupation",
    "Average Use Of Rooms": "Average Use Of Rooms",
    "Total Reservations": "Total Reservations",
    "Occupation Map": "Occupation Map",
    "Check-ins Done": "Check-ins Done",
    "Check-outs Missing": "Check-outs Missing",
    "Real Occupation": "Real Occupation",
    "Distribution of people by floor": "Distribution of people by floor",
    "Distribution throughout the day": "Distribution throughout the day",
    "Room Reservation": "Room Reservation",
    "Check-ins Ongoing": "Check-ins Ongoing",
    "button.cpe_details": "CPE Details",
    "Top Energy": "Top Energy",
    "Energy Consumption": "Energy Consumption",
    "Inductive Consumption": "Inductive Consumption",
    "Energy Produced": "Energy Produced",
    "Active Consumption": "Active Consumption",
    "Capacitive Consumption": "Capacitive Consumption",
    "Grid Injection": "Grid Injection",
    "Load Diagram": "Load Diagram",
    "Highest Registered Peak": "Highest Registered Peak",
    "Daily Power Peak": "Daily Power Peak",
    "Production Peak": "Production Peak",
    "Accumulated Emissions Avoided": "Accumulated Emissions Avoided",
    "Information From Previous Period": "Information From Previous Period",
    "Energy vs Production": "Energy vs Production",
    "Active Power and Production Power": "Active Power and Production Power",
    "Inductive Power and Capacitive Power": "Inductive Power and Capacitive Power",
    "Metric occupation": "Occupation: ",
    "Metric temperature": "Temperature: ",
    "Seats Taken": "Seats Taken",
    "Reserved Seats": "Reserved Seats",
    "Average Length of Stay": "Average Length of Stay",
    "Seat Availability": "Seat Availability",
    "Total Number of Vehicles Throughout the Day": "Total Number of Vehicles Throughout the Day",
    "Occupation by Payment Type": "Occupation by Payment Type",
    "Occupation by type of place": "Occupation by type of place",
    "Active Energy": "Active Energy",
    "Active Energy Consumption": "Active Energy Consumption",
    "Inductive Energy Consumption": "Inductive Energy Consumption",
    "Capacitive Energy Consumption": "Capacitive Energy Consumption",
    "Maximum Consumption": "Maximum Consumption",
    "Average Consumption days of the week": "Average Consumption days of the week",
    "Load Diagrams": "Load Diagrams",
    "Export": "Export",
    "It is not possible to export data for annual period": "It is not possible to export data for annual period",
    "Exportation for the selected period ": "Exportation for the selected period ",
    "Cost Estimation": "Cost Estimation",
    "Gas Consumption": "Gas Consumption",
    "Associated GEE Emissions": "Associated GEE Emissions",
    "Energetic Certification": "Energetic Certification",
    "Days of the week": "Days of the week",
    "Pick Power": "Pick Power",
    "Average Power": "Average Power",
    "Saturdays and Sundays": "Saturdays and Sundays",
    "Consumption": "Consumption",
    "Four-Hourly": "Four-Hourly",
    "Empty": "Empty",
    "Full": "Full",
    "Edge": "Edge",
    "Super Empty": "Super Empty",
    "Provided by the grid": "Provided by the grid",
    "Injected into the grid": "Injected into the grid",
    "Fixed Tariff Term": "Fixed Tariff Term",
    "Contracted Power": "Contracted Power",
    "Power at Peak Hours": "Power at Peak Hours",
    "Inductive Energy": "Inductive Energy",
    "Capacitive Energy": "Capacitive Energy",
    "Simple": "Simple",
    "Bi-hourly": "Bi-hourly",
    "Tri-hourly": "Tri-hourly",
    "Tetra-hourly": "Tetra-hourly",
    "Related Assets": "Related Assets",
    "Inductive": "Inductive",
    "Capacitive": "Capacitive",
    "Reactive Energy": "Reactive Energy",
    "Power Changes": "Power Changes",
    "Peak Hours": "Peak Hours",
    "Incident List": "Issues List",
    "Heatmap": "Heatmap",
    "button.cpe_historic": "CPE Historic",
    "Reservations": "Reserv.",
    "Extended Reservations": "Reservations",
    "Real Occupation": "Real Occ.",
    "Check-in": "Check-in",
    "Occupation": "Occupation",
    "Reserved Rooms": "Reserved Rooms",
    "Week Variation": "Week Variation",
    "Booked": "Booked",
    "Free": "Free",
    "Occupied": "Occupied",
    "Sound Level": "Sound Level",
    "Light Intensity": "Light Intensity",
    "Than": "Than",
    "Invalid POI position": "Invalid POI position",
    "Types of Access": "Types of Access",
    "Access": "Access",
    "Reservations": "Reservations",
    "Agreements": "Agreements",
    "Free Access": "Free Access",
    "Reactive Inductive Energy": "Reactive Inductive Energy",
    "Reactive Capacitive Energy": "Reactive Capacitive Energy",
    "Active Power": "Active Power",
    "Reactive Inductive Power": "Reactive Inductive Power",
    "Reactive Capacitive Power": "Reactive Capacitive Power",
    "Production Power": "Production Power",
    "Reserved": "Reserved",
    "Inductive Reactive Energy": "Inductive Reactive Energy",
    "Capacitive Reactive Energy": "Capacitive Reactive Energy",
    "Average Total": "Average Total",
    "Non-Weekend": "Non-Weekend",
    "Weekend": "Weekend",
    "Reactive Power": "Reactive Power",
    "Inductive Power": "Inductive Power",
    "Alerts": "Alerts",
    "Details": "Details",
    "Indoor Air Quality": "Indoor Air Quality",
    "input.Indicators": "Indicators",
    "input.No_Data": "No Data",
    "button.Occupation_Layer": "Occupation Layer",
    "button.Humidity_Layer": "Humidity Layer",
    "button.Temperature_Layer": "Temperature Layer",
    "button.Air_Quality_Layer": "Air Quality Layer",
    "button.Lighting_Layer": "Lighting Layer",
    "button.Noise_Layer": "Noise Layer",
    "button.Incidents_Layer": "Issues Layer",
    "button.Services_Layer": "Locations Layer",
    "message.Last_12_Hours": "Last 12 Hours",
    "button.details": "Details",

    //--------------------- EVENTS -------
    "Events Severity": "Events Severity",
    "Critical": "Critical",
    "High": "High",
    "Others": "Others",
    "Events Map": "Events Map",
    "Event Density": "Event Density",
    "message.by_severity": "By Severity",

    //--------------------- Configurations -------
    // "Configurations": "Configurations",
    "Users List": "Users List",
    "Add": "Add",
    "Edit": "Edit",
    "Estimated Value": "Estimated Value",
    "Real Value": "Real Value",
    "Average Consumption for Homologated Period": "Average Consumption for Homologated Period",
    "Active raw power": "Active raw power",
    "Maximum power allowed": "Maximum power allowed",
    "Employees": "Employees",
    "Clients": "Clients",
    "Visitors": "Visitors",
    "Contracts": "Contracts",
    "than": "than",
    "(liters)": "(liters)",
    "Widget List": "Widget List",
    "Add Widget": "Add Widget",
    "Phone Number": "Phone Number",
    "Zones": "Zones",
    "Tags": "Tags",

    "day": "day",
    "year": "year",
    "month": "month",

    "button.metric_labels_configuration": "Metric Labels Configuration",
    "button.system_label_mapping_configuration": "System Label Mapping Configuration",
    "Advanced Metrics": "Advanced Metrics",

    "Tenant": "Tenant",
    "Class": "Class",
    "Source Table": "Source Table",

    "Detail By Name": "Detail By Name",
    "Type Number": "Type Number",
    "Class Number": "Class Number",
    "Detail Number": "Detail Number",
    "Invalid cron format.": "Invalid cron format.",
    "Invalid Date": "Invalid Date",

    "Source Metric Label": "Source Metric Label",
    "Operations": "Operations",
    "Operation Horizon": "Operation Horizon",
    "Expression": "Expression",
    "Destination Metric Label": "Destination Metric Label",
    "Destination Metric Label Unit": "Destination Metric Label Unit",
    "Metric Label": "Metric Label",
    "Unit Code": "Unit Code",
    "Type": "Type",
    "Is Standard": "Is Standard",
    "Conversion": "Conversion",
    "Offset": "Offset",
    "Power": "Power",
    "Slope": "Slope",
    "Standard Unit": "Standard Unit",
    "Entity": "Entity",
    "Entity Label": "Entity Label",
    "Entity Unit": "Entity Unit",
    "System Label": "System Label",
    "System Unit": "System Unit",
    "Metric List": "Metric List",
    "Metric Label List": "Metric Label List",
    "System Label Mapping List": "System Label Mapping List",
    "Add Metric": "Add Metric",
    "Add Metric Label": "Add Metric Label",
    "Add System Label": "Add System Label",

    "Widget Type": "Widget Type",
    "Scheduler": "Scheduler",
    "Registry": "Registry",
    "Start Time": "Start Time",
    "End Time": "End Time",
    "Metric": "Metric",
    "Source Periodicity": "Source Periodicity",
    "History": "History",
    "Data Aggregation": "Data Aggregation",
    "Transformation": "Transformation",
    "Widget Dataset Name": "Widget Dataset Name",
    "Privacy": "Privacy",
    "Description": "Description",
    "Select Value": "Select Value",
    "Insert Value": "Insert Value",
    "Insert Values": "Insert Values",
    "Input Text": "Input Text",
    "Select Items": "Select Items",
    "Select Date": "Select Date",
    "Absolute": "Absolute",
    "Relative": "Relative",
    "Last": "Last",
    "Enter number and (day or hour)": "Enter number and (day or hour)",
    "Enter number and (day, month or year)": "Enter number and (day, month or year)",

    "Indicates the source of the data, which will be used to do any operation.": "Indicates the source of the data, which will be used to do any operation.",
    "Selection of all federated classes, i.e., all classes that are currently capable of receiving data. If any node is federated, it will be capable of receiving data.": "Selection of all federated classes, i.e., all classes that are currently capable of receiving data. If any node is federated, it will be capable of receiving data.",
    "Selection of all possible data tables, i.e., all tables that <tenant>  has access, that stores or will store data.": "Selection of all possible data tables, i.e., all tables that <tenant>  has access, that stores or will store data.",
    "Selection of all possible metrics, i.e., all metrics that <tenant>  has access. Note: It\'s possible to not have data for this metric, if the metric is only added and the data is not sent.": "Selection of all possible metrics, i.e., all metrics that <tenant>  has access. Note: It\'s possible to not have data for this metric, if the metric is only added and the data is not sent.",
    "This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly, i.e. the data will be aggregated by the specified period.": "This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly, i.e. the data will be aggregated by the specified period.",
    "These fields together indicates the transformation to apply to the data (Operation + Expression) and the frequency of the data processment (Operation Horizon)": "These fields together indicates the transformation to apply to the data (Operation + Expression) and the frequency of the data processment (Operation Horizon)",
    "These fields together indicates the transformation to apply to the data (Operation + Expression) and the frequency of the data processment (Operation Horizon)": "These fields together indicates the transformation to apply to the data (Operation + Expression) and the frequency of the data processment (Operation Horizon)",
    "Math Expression with the available functions": "Math Expression with the available functions",
    "Example of valid Expression: x+2": "Example of valid Expression: x+2",
    "Indicates the output label of the processed metric.": "Indicates the output label of the processed metric.",
    "Indicates the output unit of the processed metric.": "Indicates the output unit of the processed metric.",

    "Expression does not contain x variable.": "Expression does not contain x variable.",
    "Success! With": "Success! With",
    "the result was:": "the result was:",
    "Error in Expression.": "Error in Expression.",

    "Indicates the  the section of the infrastructure that will be used to create the widget.": "Indicates the  the section of the infrastructure that will be used to create the widget.",
    "Indicates the type of widget that will be generated. Each processes data in a unique way.": "Indicates the type of widget that will be generated. Each processes data in a unique way.",
    "String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC).": "String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC).",
    "Represents the type of infrastructure available, such as Buildings or Infrastructure.": "Represents the type of infrastructure available, such as Buildings or Infrastructure.",
    "Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces.": "Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces.",
    "Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually.": "Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually.",
    "Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)",
    "Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)",
    "Indicates the  the section of the infrastructure that will be used to create the widget.": "Indicates the  the section of the infrastructure that will be used to create the widget.",
    "Indicates the type of widget that will be generated. Each processes data in a unique way.": "Indicates the type of widget that will be generated. Each processes data in a unique way.",
    "String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC).": "String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC).",
    "This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly. This means the working data will be the data aggregated in the specified period.": "This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly. This means the working data will be the data aggregated in the specified period.",
    "Shows all the metrics avaible to construct the data set.": "Shows all the metrics avaible to construct the data set.",
    "Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)",
    "Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)",
    "The first field indicates which transformation to apply to the result from the available options. The second field is a valid mathematical expression that will be applied to the result after the transformation.": "The first field indicates which transformation to apply to the result from the available options. The second field is a valid mathematical expression that will be applied to the result after the transformation.",
    "Represents the type of infrastructure available, such as Buildings or Infrastructure.": "Represents the type of infrastructure available, such as Buildings or Infrastructure.",
    "Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces.": "Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces.",
    "Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually.": "Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually.",
    "The field box represents the top N from the Type category.": "The field box represents the top N from the Type category.",
    "The second box represents the top N from the Class category.": "The second box represents the top N from the Class category.",
    "The third box represents the top N from the Name category.": "The third box represents the top N from the Name category.",
    "This field indicates whether the result of the widget will include historical data. If set to True, the datasets will vary according to the specified time period.": "This field indicates whether the result of the widget will include historical data. If set to True, the datasets will vary according to the specified time period.",
    "This setup indicates how to divide the dataset according to the specified period. These selections do not affect the transformation input. The first field represents a quantifying number, and the second field specifies whether that number is in hours, days, or months.": "This setup indicates how to divide the dataset according to the specified period. These selections do not affect the transformation input. The first field represents a quantifying number, and the second field specifies whether that number is in hours, days, or months.",
    "An identified name for the widget": "An identified name for the widget",
    "Public or Private": "Public or Private",
    "A Description for the widget": "A Description for the widget",
    "Threshold List": "Threshold List",
    "Add Threshold": "Add Threshold",
    "1. Choose Affected Resource": "1. Choose Affected Resource",
    "2. Create Threshold": "2. Create Threshold",
    "Apply": "Apply",
    "Close": "Close",
    "Next": "Next",
    "Item Name": "Item Name",
    "Urgency": "Urgency",
    "Open Threshold": "Open Threshold",
    "Close Threshold": "Close Threshold",
    "Generate Incident": "Generate Issues",
    "message.services_not_found": "Resource has no corresponding Locations, therefore it is not possible to create an Issues",
    "notification.success_add_threshold": "Threshold added successfully",
    "notification.error_add_threshold": "Error adding threshold",
    "notification.success_edit_threshold": "Threshold edited successfully",
    "notification.error_edit_threshold": "Error editing threshold",
    "notification.success_remove_threshold": "Threshold removed successfully",
    "notification.error_remove_threshold": "Error removing threshold",
    "message.generate_service_not_editable": "In edit mode, it is not possible to change this",
    "button.select_metric_labels": "Select Metric Labels",
    "button.metrics_configurations": "Metrics Configurations",
    Period: 'Period',
    "input.city_service": "Location",
    "input.reporting_method": "Reporting Method",
    "input.impact": "Impact",
    "input.latitude": "Latitude",
    "input.longitude": "Longitude",
    "input.confidential": "Confidential",
    "input.description": "Description",
    "Issue Number": "Issue Number",
    "Location Name": "Location",
    "Last Update": "Last Update",
    "input.title": "Title",
    "input.severity": "Severity",
    "input.impacted_fa": "Impacted FAs",
    "input.FAOwnerGroup": "FA Owner Group",

    //--------------------- Digital Twin -------
    "Without coordinates": "Without coordinates",
    "Level 1": "Level 1",
    "Level 2": "Level 2",
    "Level 3": "Level 3",

    //--------------------- Digital Twin Metrics -------
    "Metrics": "Metrics",
    "Periodicity": "Periodicity",
    "Date": "Date",

    //--------------------- Digital Twin Drawer -------
    //Incident Drawer
    "Reference Number": "Reference Number",
    "Priority": "Severity",
    "Category": "Category",
    "Service Class": "Service Class",
    "Open Date": "Open Date",
    "Status": "Status",
    //Node Drawer
    "Name": "Name",
    "Class": "Class",
    "Family": "Family",
    "Type": "Type",
    "Label": "Label",
    "Layer": "Layer",
    //Edge Drawer
    "Weight": "Weight",
    "Is Peer": "Peer to Peer Relationship",
    "Invname": "Child Node",
    "Outvname": "Parent Node",

    //--------------------- Items Configuration -------
    "Items List": "Items List",
    "Item Details": "Item Details",
    "Mandatory Properties": "Mandatory Properties",
    "Optional Properties": "Optional Properties",
    "Create Item Tenant Description": "When you select a tenant, the family field is automatically filled with the families available for the selected tenant",
    "Create Item Family Description": "When you select a family, the class field is automatically filled with the classes available for the selected family",
    "Create Item Class Description": "When you select a class, new mandatory and optional properties appear according to the selected class",
    "Relations of": "Relations of",
    "Create Item Success": "The item has been created successfully",
    "Create Item Error": "An error occurred while creating the item",
    "Edit Item Success": "The item has been edited successfully",
    "Edit Item Error": "An error occurred while editing the item",
    "Remove Item Success": "The item has been removed successfully",
    "Remove Item Error": "An error occurred while removing the item",
    "Node already exists!": "The item already exists with the same name",
    "Edit Item": "Edit Item",
    "Delete Item": "Delete Item",
    "Item Relations": "Item Relations",
    "Create Item Federation Description": "If the field is filled, a federation will be created as an external entity",

    //--------------------- Relations Configuration -------
    "Create Relation Success": "The relation has been created successfully",
    "Create Relation Error": "An error occurred while creating the relation",
    "Remove Relation Success": "The relation has been removed successfully",
    "Remove Relation Error": "An error occurred while removing the relation",
    "The item does not exist in the parent field": "The item does not exist in the parent field",
    "The item does not exist in the child field": "The item does not exist in the child field",
    "Parent and child are the same node": "Parent and child are the same node",
    "Relationship already exists between parent and child": "Relationship already exists between parent and child",
    "Parent Item": "Parent Item",
    "Child Item": "Child Item",
    "Relation": "Relation",
};